/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Reaction_ClapInputs */

const en_us2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applause`)
};

const pt_br2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palmas`)
};

const es_419_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplausos`)
};

const pt_pt2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palmas`)
};

const fr_fr2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applaudissements`)
};

const de_de2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applaus`)
};

const it_it2_clubs_reaction_clap = /** @type {(inputs: Clubs_Reaction_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applausi`)
};

/**
* | output |
* | --- |
* | "Applause" |
*
* @param {Clubs_Reaction_ClapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_reaction_clap = /** @type {((inputs?: Clubs_Reaction_ClapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Reaction_ClapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_reaction_clap(inputs)
	if (locale === "es-419") return es_419_clubs_reaction_clap(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_reaction_clap(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_reaction_clap(inputs)
	if (locale === "de-DE") return de_de2_clubs_reaction_clap(inputs)
	if (locale === "it-IT") return it_it2_clubs_reaction_clap(inputs)
	return en_us2_clubs_reaction_clap(inputs)
});
export { clubs_reaction_clap as "clubs.reaction_clap" }